module.exports = __webpack_public_path__ + "fonts/7c661b8c6b53ee5ba9c0a0c7fad8ff33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/vehicle.svg
// module id = 285
// module chunks = 0